/**
 * SystemService
 * Service for System operations
 * Route: api/system
 */
import { BaseService } from '../base/BaseService';
/**
 * SystemHealthService
 * Handles system health checks and cache management
 */
export class SystemHealthService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SystemHealthService.DEFAULT_SERVICE_PATH,
            basePath: SystemHealthService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== HEALTH CHECK ====================
    /**
     * Health check endpoint
     * GET api/system/health
     */
    async healthCheck() {
        const response = await this.healthCheckRaw();
        if (!response.data) {
            throw new Error('Health check failed');
        }
        return response.data;
    }
    /**
     * Health check with full response
     */
    healthCheckRaw() {
        const endpoint = this.getEndpoint('health', 'health');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== CACHE STATS ====================
    /**
     * Get cache statistics
     * GET api/system/cache/stats
     */
    async getCacheStats() {
        const response = await this.getCacheStatsRaw();
        if (!response.data) {
            throw new Error('Failed to get cache stats');
        }
        return response.data;
    }
    /**
     * Get cache statistics with full response
     */
    getCacheStatsRaw() {
        const endpoint = this.getEndpoint('cache-stats', 'cache/stats');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== CLEAR CACHE ====================
    /**
     * Clear all cache
     * POST api/system/cache/clear
     */
    async clearCache() {
        const response = await this.clearCacheRaw();
        return response.success;
    }
    /**
     * Clear all cache with full response
     */
    clearCacheRaw() {
        const endpoint = this.getEndpoint('cache-clear', 'cache/clear');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
    // ==================== APPLICATION INFO ====================
    /**
     * Get application info
     * GET api/system/info
     */
    async getInfo() {
        const response = await this.getInfoRaw();
        if (!response.data) {
            throw new Error('Failed to get application info');
        }
        return response.data;
    }
    /**
     * Get application info with full response
     */
    getInfoRaw() {
        const endpoint = this.getEndpoint('info', 'info');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== DEBUG MY CACHE ====================
    /**
     * Get current user's cache debug info (for development/debugging)
     * GET api/system/debug/my-cache
     */
    async getMyCache() {
        const response = await this.getMyCacheRaw();
        if (!response.data) {
            throw new Error('Failed to get cache debug info');
        }
        return response.data;
    }
    /**
     * Get current user's cache debug info with full response
     */
    getMyCacheRaw() {
        const endpoint = this.getEndpoint('debug-my-cache', 'debug/my-cache');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
SystemHealthService.DEFAULT_SERVICE_PATH = 'users';
SystemHealthService.BASE_PATH = 'api/system';
//# sourceMappingURL=SystemService.js.map